export const Rights = [
    "WEB_MODULE_CALENDAR_READ"
]
